export const parseIntSafe = (value, returnNanValue) => {
  const parsedValue = parseInt(value, 10);
  const isNaN = Number.isNaN(parsedValue);
  if (isNaN && returnNanValue !== undefined) return returnNanValue;
  return Number.isNaN(parsedValue) ? 0 : parsedValue;
};
